import HelpLink from 'App/HelpLink/HelpLink';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

function DraftOrdersHelpLink(): JSX.Element {
  const t = useTranslationOrders();

  return (
    <HelpLink
      title={t('draftOrders.helpLink.aboutOrders')}
      linkURL={t('draftOrders.helpLink.aboutOrdersUrl')}
      currentViewTracking={t('draftOrders.helpLink.aboutOrdersTrackingName')}
      previousValue="draft_order_list"
      icon="both"
      showInMobile
    />
  );
}

export default DraftOrdersHelpLink;
